import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ErrorBoundary } from '@sentry/react';
import { memo, ReactNode, Suspense } from 'react';
import { ActivityIndicator } from 'react-native';

export const TableCellDetailLabel = memo(
  ({
    errorIconSize,
    activityIndicatorColor = '#777',
    children,
  }: {
    errorIconSize?: number;
    activityIndicatorColor?: string;
    children?: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    errorIconSize = errorIconSize ?? rpx(18);
    return (
      <ErrorBoundary
        // @ts-ignore
        fallback={
          <Icon
            name="warning"
            color={StatusColors.Danger}
            size={errorIconSize}
          />
        }
      >
        <Suspense
          fallback={
            <ActivityIndicator
              size="small"
              color={activityIndicatorColor}
              css={`
                transform: scale(${rpx(0.7)});
              `}
            />
          }
        >
          {children}
        </Suspense>
      </ErrorBoundary>
    );
  },
);
